<div class="fs-2 with-close" mat-dialog-title>
    Cette annonce est réservée à nos membres premium
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true" *ngIf="data.close"></i>
</div>
<div mat-dialog-content>
    <b>
        Rejoignez LyBox dès maintenant pour découvrir les meilleures opportunités.
    </b>
    <div class="row d-flex justify-content-around align-items-stretch pricing mt-3">
        <div class="col-12 col-lg-6 p-2 col-essentiel">
            <div class="pricing-light pt-3 pb-2 text-center">
                <h2 class="fs-3 pb-3 essentiel pb-3">Essentiel</h2>
                <p class="desc">
                    Pour les investisseurs <b>en recherche active</b> qui souhaitent trouver des biens rentables.
                </p>
                <b class="price pricing-mensuel-value"
                   *ngIf="user.p == '0' || user.p == '1'">39,90€<span
                    class="fs-5">/mois</span></b>

                <b class="price pricing-mensuel-value" *ngIf="user.p == '2'">19,90€<span
                    class="fs-5">/mois</span></b>

                <b class="price pricing-mensuel-value" *ngIf="user.p == '3'">29€<span
                    class="fs-5">/mois</span></b>
                <ul class="pricing-features mt-3">
                    <li>Analyse du marché immobilier</li>
                    <li>
                        Calcul de rendement et de CF
                        <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                           matTooltip="Simulateur d’investissement locatif : Calculez simplement et rapidement le rendement, le cash-flow et la fiscalité de votre investissement locatif sur les 30 prochaines années"></i>
                    </li>
                    <li>Simulation en Foncier et LMNP
                        <i class="fa fa-question-circle ms-2"
                           matTooltipClass="tooltip-button"
                           matTooltip="Foncier forfait, foncier réel, LMNP forfait, LMNP réel"></i>
                    </li>
                    <li>
                        Moteur de recherche spécial investisseur (1500 sites réunis)
                        <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                           matTooltip="Moteur de recherche immobilier : Retrouvez toutes les annonces immobilières du web au même endroit. Faites des recherches précises en se basant sur plus de 30 critères conçus pour les investisseurs"></i>
                    </li>
                    <li>Filtres de recherche avancés</li>
                    <li>
                        Alertes mails en direct
                        <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                           matTooltip="Alertes mails en direct : Soyez avertis automatiquement lorsqu’une nouvelle annonce qui correspond à vos critères est publiée sur n’importe quel site immobilier"></i>
                    </li>
                    <li>
                        Trouver les villes rentables
                        <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                           matTooltip="Trouver les villes rentables : Un module de recherche vous permet de trouver les villes à potentiel dans votre département ou autour de chez vous, en fonction de vos objectifs d’investissement"></i>
                    </li>
                    <li>Imposition à la revente
                        <i class="fa fa-question-circle ms-2"
                           matTooltipClass="tooltip-button"
                           matTooltip="Calculez l'impôt sur la plus value en fonction de votre situation, votre régime fiscal et l'année de revente"></i></li>
                    <li>Simulation en SCI à l’IS</li>
                    <li>20 analyses IA par mois
                        <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                           [matTooltip]="aiCreditTooltip"></i>
                    </li>
                </ul>
                <a class="btn btn-outline-primary"
                   *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == ''"
                   (click)="onYesClick('essentiel')">Sélectionner
                </a>
            </div>
        </div>
        <div class="col-12 col-lg-6 p-2 col-expert">
            <div class="pricing-light pt-3 pb-2 text-center">
                <h2 class="fs-3 expert pb-3">Expert</h2>
                <p class="desc">
                    Pour les investisseurs exigeants qui veulent être les premiers sur les meilleures affaires.
                </p>
                <b class="price pricing-mensuel-value"
                   *ngIf="user.p == '0' || user.p == '1'">59,90€<span
                    class="fs-5">/mois</span></b>

                <b class="price pricing-mensuel-value" *ngIf="user.p == '2'">29,90€<span
                    class="fs-5">/mois</span></b>

                <b class="price pricing-mensuel-value" *ngIf="user.p == '3'">59€<span
                    class="fs-5">/mois</span></b>

                <h4>Fonctionnalités dans Essentiel, et :</h4>
                <ul class="pricing-features mt-3">
                    <li>
                        Dossier bancaire en PDF
                        <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                           matTooltip="Dossier bancaire : Mettez toutes les chances de votre côté pour obtenir votre crédit immobilier. Vous pourrez générer un rapport d’investissement professionnel en PDF détaillant chaque aspect de votre projet immobilier"></i>
                    </li>
                    <li>Accès aux locaux commerciaux</li>
                    <li>Personnalisation avancée
                        <i class="fa fa-question-circle ms-2"
                           matTooltipClass="tooltip-button"
                           matTooltip="Personnalisation des indicateurs dans les résultats de recherches et les favoris"></i></li>
                    <li>Simulation en LMP, SASU, EURL ...</li>
                    <li>100 analyses IA par mois
                        <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                           [matTooltip]="aiCreditTooltip"></i>
                    </li>
                    <li>Connecteur MCP pour votre IA
                        <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                           matTooltip="Utilisez LyBox directement depuis votre IA (Claude, ChatGPT…) : recherche d'annonces, rendement et cash-flow, données de marché, favoris, secteurs et alertes"></i>
                        <br/><br/>
                    </li>
                </ul>
                <a class="btn btn-primary"
                   *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == ''"
                   (click)="onYesClick('expert')">Sélectionner
                </a>
            </div>
        </div>
    </div>
</div>
